import CustomButton from '../../../common/components/CustomButton';

export default function KaraokeDetailsFormView({
  karaokeOrder,
  isRoyaltyOptionSelected,
  isWaitingForPayment,
  isWaitingForUpload,
  isDeliveryCompleted,
  isRegistrationInProgress,
  distributionStatusText,
  onResumePayment,
  onResumeUpload,
  onRequestModification,
  onCancelDistribution,
  onStartRegistration,
  onCancelRegistration,
} : {
  karaokeOrder: {
    title: string,
    title_kana: string,
    artist_name: string,
    artist_name_kana: string,
    lyric_writer_name: string,
    composer_name: string,
    applicant_name: string,
    physical: number,
    already_entrusted: number,
    onvocal: number,
    duet: number,
  },
  isRoyaltyOptionSelected: boolean,
  isWaitingForPayment: boolean,
  isWaitingForUpload: boolean,
  isDeliveryCompleted: boolean,
  isRegistrationInProgress: boolean,
  distributionStatusText: string,
  onResumePayment: () => void,
  onResumeUpload: () => void,
  onRequestModification: () => void,
  onCancelDistribution: () => void,
  onStartRegistration: () => void,
  onCancelRegistration: () => void,
}) {
  return (
    <>
      <h2>{distributionStatusText}</h2>
      <p className="song_ttl">{`曲名:${karaokeOrder.title}`}</p>
      <form>
        <div className="form__body preview">
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>曲名</label></dt>
            <dd>{karaokeOrder.title}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>曲名読み</label></dt>
            <dd>{karaokeOrder.title_kana}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>アーティスト名</label></dt>
            <dd>{karaokeOrder.artist_name}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>アーティスト名読み</label></dt>
            <dd>{karaokeOrder.artist_name_kana}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>作詞者名</label></dt>
            <dd>{karaokeOrder.lyric_writer_name}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>作曲者名</label></dt>
            <dd>{karaokeOrder.composer_name}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>申込者名</label></dt>
            <dd>{karaokeOrder.applicant_name}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>申し込む曲はJASRAC/NexToneに著作権管理を委託している、または委託予定です（作詞作曲者がJASRAC会員である場合を含む）</label></dt>
            <dd>{karaokeOrder.already_entrusted !== 0 ? 'はい' : 'いいえ'}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>本人歌唱</label></dt>
            <dd>{karaokeOrder.onvocal !== 0 ? 'あり' : 'なし'}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>郵送</label></dt>
            <dd>{karaokeOrder.physical !== 0 ? 'あり' : 'なし'}</dd>
          </dl>
          <dl>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <dt><label>デュエット</label></dt>
            <dd>{karaokeOrder.duet !== 0 ? 'あり' : 'なし'}</dd>
          </dl>
          <div className="d-flex">
            <dl>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <dt><label>印税受け取り</label></dt>
              <dd>
                {isRoyaltyOptionSelected ? 'あり' : 'なし'}
                {isRoyaltyOptionSelected && isWaitingForPayment && '（支払待ち）'}
                {isRoyaltyOptionSelected && isRegistrationInProgress && '（手続き中）'}
              </dd>
            </dl>
            <ul className="table_layout" style={{ display: 'none' }}>
              <li className="bt">
                <CustomButton
                  type="default"
                  onClick={() => {
                    if (isRoyaltyOptionSelected) {
                      onCancelRegistration();
                    } else {
                      onStartRegistration();
                    }
                  }}
                >
                  {isRoyaltyOptionSelected && (isDeliveryCompleted ? '著作権管理委託を終了' : '印税なしに変更')}
                  {!isRoyaltyOptionSelected && '印税ありに変更'}
                </CustomButton>
              </li>
            </ul>
            <dl />
          </div>
          <p className="top_line" />
          {(isWaitingForPayment || (isWaitingForUpload && karaokeOrder.physical === 0)) && (
            <ul>
              <li className="bt">
                <CustomButton
                  type="default"
                  onClick={() => {
                    if (isWaitingForPayment) {
                      onResumePayment();
                    } else if (isWaitingForUpload) {
                      onResumeUpload();
                    }
                  }}
                >
                  次の手続きへ
                </CustomButton>
              </li>
            </ul>
          )}
          <ul>
            <li className="d-block">
              <CustomButton type="secondary-default" onClick={() => onRequestModification()}>修正依頼</CustomButton>
              <CustomButton type="secondary-cancel" onClick={() => onCancelDistribution()}>
                {isDeliveryCompleted ? '配信停止' : '申込キャンセル'}
              </CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </>
  );
}
